
import {Component} from 'vue-property-decorator'
import {validationMixin} from 'vuelidate'
import {namespace} from 'vuex-class'
import {required, email} from 'vuelidate/lib/validators'
import SelectRef from '@/components/common/SelectRef.vue'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import ConseillerModel from '@/models/ConseillerModel'
import convertTelNumberDirective from '@/directives/convertTelNumberDirective'
import {isCoprolibTelNumber} from '@/helpers/validators'

const uiModule = namespace('ui')
const authModule = namespace('auth')

@Component({
  mixins: [validationMixin],
  components: {
    BaseFormContainer,
    SelectRef
  },
  directives: {
    convertTelNumberDirective
  },
  validations: {
    form: {
      NOM: {
        required
      },
      TELEPHONE: {
        isCoprolibTelNumber
      },
      MOBILE: {
        isCoprolibTelNumber
      },
      EMAIL: {
        email
      }
    }
  }
})
export default class App extends BaseForm {
  @authModule.Getter('meGetter') me: any
  @uiModule.Getter('isLoadingGetter') isLoading: any

  model = ConseillerModel
}
